import React, { useEffect, useState } from "react";
import { useAuth } from "./hooks/useAuth";
import AuthPage from "./pages/AuthPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SuperAdminApp from "./components/SuperAdminApp";
import RegularUserApp from "./components/RegularUserApp";
import { SpinnerCustom } from "./components/ui/Spinner";

function App() {
  const { isAuthenticated, user, login, isInitializing } = useAuth();
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const isSuperAdmin = user?.role === "super_admin";

  // Listen for pathname changes
  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    // Listen for popstate (back/forward buttons)
    window.addEventListener("popstate", handleLocationChange);

    // Check pathname on mount and when auth state changes
    handleLocationChange();

    return () => {
      window.removeEventListener("popstate", handleLocationChange);
    };
  }, [isAuthenticated]);

  // Full-page loader on browser refresh / initial load (same as Reports & Master Address)
  const [showRefreshLoader, setShowRefreshLoader] = useState(true);
  useEffect(() => {
    if (!isInitializing) {
      const t = setTimeout(() => setShowRefreshLoader(false), 100);
      return () => clearTimeout(t);
    }
  }, [isInitializing]);
  if (showRefreshLoader) {
    return (
      <div className="min-h-screen pt-[155px] bg-gradient-to-b from-gray-50 to-white flex items-center justify-center">
        <div className="flex flex-col items-center">
          <SpinnerCustom />
        </div>
      </div>
    );
  }

  // Handle reset password route
  if (currentPath === "/reset-password" || currentPath === "/reset-password/") {
    return <ResetPasswordPage />;
  }

  if (!isAuthenticated) {
    return <AuthPage onLogin={login} />;
  }

  if (isSuperAdmin) {
    return <SuperAdminApp />;
  }

  return <RegularUserApp />;
}

export default App;
